import FormicaCalendarComponent from '../custom/FormicaCalendarComponent';
import useDashboardEmailSendTime, { DashboardEmailSendTime } from './useDashboardEmailSendTime';

interface Props {
  hour: number | undefined;
  minute: number | undefined;
  onChange: (time: DashboardEmailSendTime) => void;
}

function DashboardEmailTimePickerComponent({ hour, minute, onChange }: Props) {
  const { value, handleChange } = useDashboardEmailSendTime(hour, minute, onChange);

  return (
    <FormicaCalendarComponent
      value={value}
      onChange={handleChange}
      timeOnly
      hourFormat='24'
      stepMinute={1}
    />
  );
}

export default DashboardEmailTimePickerComponent;
